module.exports = {
	"textures": [
		{
			"image": "TrackSpriteSheet.png",
			"format": "RGBA8888",
			"size": {
				"w": 2048,
				"h": 2048
			},
			"scale": 1,
			"frames": [
				{
					"filename": "track_background.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 1164,
						"h": 436
					},
					"spriteSourceSize": {
						"x": 19,
						"y": 46,
						"w": 1133,
						"h": 346
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 1133,
						"h": 346
					}
				},
				{
					"filename": "track_button_21.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 268,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 268,
						"h": 110
					},
					"frame": {
						"x": 1136,
						"y": 1,
						"w": 268,
						"h": 110
					}
				},
				{
					"filename": "track_button_21_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 268,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 268,
						"h": 110
					},
					"frame": {
						"x": 1406,
						"y": 1,
						"w": 268,
						"h": 110
					}
				},
				{
					"filename": "track_button_21_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 268,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 268,
						"h": 110
					},
					"frame": {
						"x": 1676,
						"y": 1,
						"w": 268,
						"h": 110
					}
				},
				{
					"filename": "track_button_32.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 98,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 98,
						"h": 105
					},
					"frame": {
						"x": 1946,
						"y": 1,
						"w": 98,
						"h": 105
					}
				},
				{
					"filename": "track_button_32_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 98,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 98,
						"h": 105
					},
					"frame": {
						"x": 1946,
						"y": 108,
						"w": 98,
						"h": 105
					}
				},
				{
					"filename": "track_button_36.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 268,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 268,
						"h": 110
					},
					"frame": {
						"x": 1136,
						"y": 113,
						"w": 268,
						"h": 110
					}
				},
				{
					"filename": "track_button_36_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 268,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 268,
						"h": 110
					},
					"frame": {
						"x": 1406,
						"y": 113,
						"w": 268,
						"h": 110
					}
				},
				{
					"filename": "track_button_36_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 268,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 268,
						"h": 110
					},
					"frame": {
						"x": 1676,
						"y": 113,
						"w": 268,
						"h": 110
					}
				},
				{
					"filename": "track_button_32_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 98,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 98,
						"h": 105
					},
					"frame": {
						"x": 1946,
						"y": 215,
						"w": 98,
						"h": 105
					}
				},
				{
					"filename": "track_button_28.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 266,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 266,
						"h": 110
					},
					"frame": {
						"x": 1136,
						"y": 225,
						"w": 266,
						"h": 110
					}
				},
				{
					"filename": "track_button_28_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 266,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 266,
						"h": 110
					},
					"frame": {
						"x": 1404,
						"y": 225,
						"w": 266,
						"h": 110
					}
				},
				{
					"filename": "track_button_28_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 266,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 266,
						"h": 110
					},
					"frame": {
						"x": 1672,
						"y": 225,
						"w": 266,
						"h": 110
					}
				},
				{
					"filename": "track_button_26.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 97,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 97,
						"h": 105
					},
					"frame": {
						"x": 1940,
						"y": 322,
						"w": 97,
						"h": 105
					}
				},
				{
					"filename": "track_button_20.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 265,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 265,
						"h": 109
					},
					"frame": {
						"x": 1136,
						"y": 337,
						"w": 265,
						"h": 109
					}
				},
				{
					"filename": "track_button_20_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 265,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 265,
						"h": 109
					},
					"frame": {
						"x": 1403,
						"y": 337,
						"w": 265,
						"h": 109
					}
				},
				{
					"filename": "track_button_20_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 265,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 265,
						"h": 109
					},
					"frame": {
						"x": 1670,
						"y": 337,
						"w": 265,
						"h": 109
					}
				},
				{
					"filename": "track_button_26_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 97,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 97,
						"h": 105
					},
					"frame": {
						"x": 1937,
						"y": 429,
						"w": 97,
						"h": 105
					}
				},
				{
					"filename": "track_button_2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 264,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 264,
						"h": 105
					},
					"frame": {
						"x": 1,
						"y": 349,
						"w": 264,
						"h": 105
					}
				},
				{
					"filename": "track_button_2_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 264,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 264,
						"h": 105
					},
					"frame": {
						"x": 267,
						"y": 349,
						"w": 264,
						"h": 105
					}
				},
				{
					"filename": "track_button_2_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 264,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 264,
						"h": 105
					},
					"frame": {
						"x": 533,
						"y": 349,
						"w": 264,
						"h": 105
					}
				},
				{
					"filename": "track_button_11.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 261,
						"h": 111
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 261,
						"h": 111
					},
					"frame": {
						"x": 799,
						"y": 349,
						"w": 261,
						"h": 111
					}
				},
				{
					"filename": "track_button_11_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 261,
						"h": 111
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 261,
						"h": 111
					},
					"frame": {
						"x": 1,
						"y": 456,
						"w": 261,
						"h": 111
					}
				},
				{
					"filename": "track_button_11_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 261,
						"h": 111
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 261,
						"h": 111
					},
					"frame": {
						"x": 264,
						"y": 456,
						"w": 261,
						"h": 111
					}
				},
				{
					"filename": "track_button_1.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 108
					},
					"frame": {
						"x": 527,
						"y": 456,
						"w": 260,
						"h": 108
					}
				},
				{
					"filename": "track_button_1_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 108
					},
					"frame": {
						"x": 1062,
						"y": 448,
						"w": 260,
						"h": 108
					}
				},
				{
					"filename": "track_button_1_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 108
					},
					"frame": {
						"x": 789,
						"y": 462,
						"w": 260,
						"h": 108
					}
				},
				{
					"filename": "track_button_7.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 105
					},
					"frame": {
						"x": 527,
						"y": 566,
						"w": 260,
						"h": 105
					}
				},
				{
					"filename": "track_button_7_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 105
					},
					"frame": {
						"x": 1,
						"y": 569,
						"w": 260,
						"h": 105
					}
				},
				{
					"filename": "track_button_7_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 105
					},
					"frame": {
						"x": 263,
						"y": 569,
						"w": 260,
						"h": 105
					}
				},
				{
					"filename": "track_button_13.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 254,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 254,
						"h": 102
					},
					"frame": {
						"x": 1324,
						"y": 448,
						"w": 254,
						"h": 102
					}
				},
				{
					"filename": "track_button_13_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 254,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 254,
						"h": 102
					},
					"frame": {
						"x": 1580,
						"y": 448,
						"w": 254,
						"h": 102
					}
				},
				{
					"filename": "track_button_18.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 211,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 211,
						"h": 82
					},
					"frame": {
						"x": 1836,
						"y": 536,
						"w": 211,
						"h": 82
					}
				},
				{
					"filename": "track_button_13_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 254,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 254,
						"h": 102
					},
					"frame": {
						"x": 1324,
						"y": 552,
						"w": 254,
						"h": 102
					}
				},
				{
					"filename": "track_button_14.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 253,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 253,
						"h": 102
					},
					"frame": {
						"x": 1580,
						"y": 552,
						"w": 253,
						"h": 102
					}
				},
				{
					"filename": "track_button_18_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 211,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 211,
						"h": 82
					},
					"frame": {
						"x": 1835,
						"y": 620,
						"w": 211,
						"h": 82
					}
				},
				{
					"filename": "track_button_14_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 253,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 253,
						"h": 102
					},
					"frame": {
						"x": 1051,
						"y": 558,
						"w": 253,
						"h": 102
					}
				},
				{
					"filename": "track_button_14_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 253,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 253,
						"h": 102
					},
					"frame": {
						"x": 789,
						"y": 572,
						"w": 253,
						"h": 102
					}
				},
				{
					"filename": "track_button_25.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 241,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 241,
						"h": 94
					},
					"frame": {
						"x": 525,
						"y": 673,
						"w": 241,
						"h": 94
					}
				},
				{
					"filename": "track_button_25_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 241,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 241,
						"h": 94
					},
					"frame": {
						"x": 1,
						"y": 676,
						"w": 241,
						"h": 94
					}
				},
				{
					"filename": "track_button_25_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 241,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 241,
						"h": 94
					},
					"frame": {
						"x": 244,
						"y": 676,
						"w": 241,
						"h": 94
					}
				},
				{
					"filename": "track_button_12.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 240,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 240,
						"h": 104
					},
					"frame": {
						"x": 1306,
						"y": 656,
						"w": 240,
						"h": 104
					}
				},
				{
					"filename": "track_button_12_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 240,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 240,
						"h": 104
					},
					"frame": {
						"x": 1044,
						"y": 662,
						"w": 240,
						"h": 104
					}
				},
				{
					"filename": "track_button_12_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 240,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 240,
						"h": 104
					},
					"frame": {
						"x": 768,
						"y": 676,
						"w": 240,
						"h": 104
					}
				},
				{
					"filename": "track_button_29.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 240,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 240,
						"h": 94
					},
					"frame": {
						"x": 487,
						"y": 769,
						"w": 240,
						"h": 94
					}
				},
				{
					"filename": "track_button_29_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 240,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 240,
						"h": 94
					},
					"frame": {
						"x": 1548,
						"y": 656,
						"w": 240,
						"h": 94
					}
				},
				{
					"filename": "track_button_29_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 240,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 240,
						"h": 94
					},
					"frame": {
						"x": 1790,
						"y": 704,
						"w": 240,
						"h": 94
					}
				},
				{
					"filename": "track_button_4.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 239,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 239,
						"h": 104
					},
					"frame": {
						"x": 1548,
						"y": 752,
						"w": 239,
						"h": 104
					}
				},
				{
					"filename": "track_button_4_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 239,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 239,
						"h": 104
					},
					"frame": {
						"x": 1789,
						"y": 800,
						"w": 239,
						"h": 104
					}
				},
				{
					"filename": "track_button_4_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 239,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 239,
						"h": 104
					},
					"frame": {
						"x": 1286,
						"y": 762,
						"w": 239,
						"h": 104
					}
				},
				{
					"filename": "track_button_27.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 226,
						"h": 90
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 226,
						"h": 90
					},
					"frame": {
						"x": 1527,
						"y": 858,
						"w": 226,
						"h": 90
					}
				},
				{
					"filename": "track_button_27_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 226,
						"h": 90
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 226,
						"h": 90
					},
					"frame": {
						"x": 1010,
						"y": 768,
						"w": 226,
						"h": 90
					}
				},
				{
					"filename": "track_button_27_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 226,
						"h": 90
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 226,
						"h": 90
					},
					"frame": {
						"x": 729,
						"y": 782,
						"w": 226,
						"h": 90
					}
				},
				{
					"filename": "track_button_31.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 226,
						"h": 89
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 226,
						"h": 89
					},
					"frame": {
						"x": 1755,
						"y": 906,
						"w": 226,
						"h": 89
					}
				},
				{
					"filename": "track_button_31_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 226,
						"h": 89
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 226,
						"h": 89
					},
					"frame": {
						"x": 957,
						"y": 860,
						"w": 226,
						"h": 89
					}
				},
				{
					"filename": "track_button_26_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 97,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 97,
						"h": 105
					},
					"frame": {
						"x": 1185,
						"y": 860,
						"w": 97,
						"h": 105
					}
				},
				{
					"filename": "track_button_31_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 226,
						"h": 89
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 226,
						"h": 89
					},
					"frame": {
						"x": 1284,
						"y": 868,
						"w": 226,
						"h": 89
					}
				},
				{
					"filename": "track_button_30.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 109
					},
					"frame": {
						"x": 1512,
						"y": 950,
						"w": 215,
						"h": 109
					}
				},
				{
					"filename": "track_button_30_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 109
					},
					"frame": {
						"x": 1284,
						"y": 959,
						"w": 215,
						"h": 109
					}
				},
				{
					"filename": "track_button_30_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 109
					},
					"frame": {
						"x": 1729,
						"y": 997,
						"w": 215,
						"h": 109
					}
				},
				{
					"filename": "track_button_33.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 107
					},
					"frame": {
						"x": 1501,
						"y": 1061,
						"w": 215,
						"h": 107
					}
				},
				{
					"filename": "track_button_5.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 84,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 84,
						"h": 109
					},
					"frame": {
						"x": 1946,
						"y": 997,
						"w": 84,
						"h": 109
					}
				},
				{
					"filename": "track_button_33_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 107
					},
					"frame": {
						"x": 1718,
						"y": 1108,
						"w": 215,
						"h": 107
					}
				},
				{
					"filename": "track_button_5_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 84,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 84,
						"h": 109
					},
					"frame": {
						"x": 1935,
						"y": 1108,
						"w": 84,
						"h": 109
					}
				},
				{
					"filename": "track_button_33_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 107
					},
					"frame": {
						"x": 1,
						"y": 772,
						"w": 215,
						"h": 107
					}
				},
				{
					"filename": "track_button_17.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 82
					},
					"frame": {
						"x": 218,
						"y": 772,
						"w": 215,
						"h": 82
					}
				},
				{
					"filename": "track_button_17_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 82
					},
					"frame": {
						"x": 218,
						"y": 856,
						"w": 215,
						"h": 82
					}
				},
				{
					"filename": "track_button_17_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 82
					},
					"frame": {
						"x": 1,
						"y": 881,
						"w": 215,
						"h": 82
					}
				},
				{
					"filename": "track_button_18_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 211,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 211,
						"h": 82
					},
					"frame": {
						"x": 435,
						"y": 865,
						"w": 211,
						"h": 82
					}
				},
				{
					"filename": "track_button_6.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 199,
						"h": 75
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 199,
						"h": 75
					},
					"frame": {
						"x": 218,
						"y": 940,
						"w": 199,
						"h": 75
					}
				},
				{
					"filename": "track_button_6_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 199,
						"h": 75
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 199,
						"h": 75
					},
					"frame": {
						"x": 1,
						"y": 965,
						"w": 199,
						"h": 75
					}
				},
				{
					"filename": "track_button_6_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 199,
						"h": 75
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 199,
						"h": 75
					},
					"frame": {
						"x": 648,
						"y": 874,
						"w": 199,
						"h": 75
					}
				},
				{
					"filename": "track_button_5_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 84,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 84,
						"h": 109
					},
					"frame": {
						"x": 849,
						"y": 874,
						"w": 84,
						"h": 109
					}
				},
				{
					"filename": "track_button_9.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 195,
						"h": 74
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 195,
						"h": 74
					},
					"frame": {
						"x": 419,
						"y": 949,
						"w": 195,
						"h": 74
					}
				},
				{
					"filename": "track_button_9_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 195,
						"h": 74
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 195,
						"h": 74
					},
					"frame": {
						"x": 202,
						"y": 1017,
						"w": 195,
						"h": 74
					}
				},
				{
					"filename": "track_button_9_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 195,
						"h": 74
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 195,
						"h": 74
					},
					"frame": {
						"x": 1,
						"y": 1042,
						"w": 195,
						"h": 74
					}
				},
				{
					"filename": "track_button_19.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 105
					},
					"frame": {
						"x": 616,
						"y": 951,
						"w": 183,
						"h": 105
					}
				},
				{
					"filename": "track_button_19_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 105
					},
					"frame": {
						"x": 399,
						"y": 1025,
						"w": 183,
						"h": 105
					}
				},
				{
					"filename": "track_button_19_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 105
					},
					"frame": {
						"x": 198,
						"y": 1093,
						"w": 183,
						"h": 105
					}
				},
				{
					"filename": "track_button_35.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 105
					},
					"frame": {
						"x": 1,
						"y": 1118,
						"w": 183,
						"h": 105
					}
				},
				{
					"filename": "track_button_35_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 105
					},
					"frame": {
						"x": 935,
						"y": 951,
						"w": 183,
						"h": 105
					}
				},
				{
					"filename": "track_button_16.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 160,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 160,
						"h": 109
					},
					"frame": {
						"x": 1120,
						"y": 967,
						"w": 160,
						"h": 109
					}
				},
				{
					"filename": "paint_mode_normal.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 801,
						"y": 985,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "track_button_35_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 105
					},
					"frame": {
						"x": 931,
						"y": 1058,
						"w": 183,
						"h": 105
					}
				},
				{
					"filename": "track_button_34.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 71
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 71
					},
					"frame": {
						"x": 584,
						"y": 1058,
						"w": 183,
						"h": 71
					}
				},
				{
					"filename": "track_button_16_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 160,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 160,
						"h": 109
					},
					"frame": {
						"x": 769,
						"y": 1097,
						"w": 160,
						"h": 109
					}
				},
				{
					"filename": "track_button_34_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 71
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 71
					},
					"frame": {
						"x": 584,
						"y": 1131,
						"w": 183,
						"h": 71
					}
				},
				{
					"filename": "track_button_34_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 71
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 71
					},
					"frame": {
						"x": 383,
						"y": 1132,
						"w": 183,
						"h": 71
					}
				},
				{
					"filename": "track_button_22.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 181,
						"h": 72
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 181,
						"h": 72
					},
					"frame": {
						"x": 186,
						"y": 1200,
						"w": 181,
						"h": 72
					}
				},
				{
					"filename": "track_button_22_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 181,
						"h": 72
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 181,
						"h": 72
					},
					"frame": {
						"x": 1,
						"y": 1225,
						"w": 181,
						"h": 72
					}
				},
				{
					"filename": "track_button_22_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 181,
						"h": 72
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 181,
						"h": 72
					},
					"frame": {
						"x": 568,
						"y": 1204,
						"w": 181,
						"h": 72
					}
				},
				{
					"filename": "track_button_16_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 160,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 160,
						"h": 109
					},
					"frame": {
						"x": 369,
						"y": 1205,
						"w": 160,
						"h": 109
					}
				},
				{
					"filename": "track_button_8.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 159,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 159,
						"h": 109
					},
					"frame": {
						"x": 184,
						"y": 1274,
						"w": 159,
						"h": 109
					}
				},
				{
					"filename": "track_button_8_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 159,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 159,
						"h": 109
					},
					"frame": {
						"x": 1,
						"y": 1299,
						"w": 159,
						"h": 109
					}
				},
				{
					"filename": "track_button_8_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 159,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 159,
						"h": 109
					},
					"frame": {
						"x": 1282,
						"y": 1070,
						"w": 159,
						"h": 109
					}
				},
				{
					"filename": "payout_button2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 150,
						"h": 150
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 150,
						"h": 150
					},
					"frame": {
						"x": 1116,
						"y": 1078,
						"w": 150,
						"h": 150
					}
				},
				{
					"filename": "track_button_15.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 136,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 136,
						"h": 105
					},
					"frame": {
						"x": 931,
						"y": 1165,
						"w": 136,
						"h": 105
					}
				},
				{
					"filename": "track_button_15_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 136,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 136,
						"h": 105
					},
					"frame": {
						"x": 751,
						"y": 1208,
						"w": 136,
						"h": 105
					}
				},
				{
					"filename": "track_button_15_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 136,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 136,
						"h": 105
					},
					"frame": {
						"x": 531,
						"y": 1278,
						"w": 136,
						"h": 105
					}
				},
				{
					"filename": "track_button_3.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 134,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 134,
						"h": 105
					},
					"frame": {
						"x": 345,
						"y": 1316,
						"w": 134,
						"h": 105
					}
				},
				{
					"filename": "track_button_3_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 134,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 134,
						"h": 105
					},
					"frame": {
						"x": 162,
						"y": 1385,
						"w": 134,
						"h": 105
					}
				},
				{
					"filename": "track_button_3_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 134,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 134,
						"h": 105
					},
					"frame": {
						"x": 1,
						"y": 1410,
						"w": 134,
						"h": 105
					}
				},
				{
					"filename": "paint_mode_selected.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 1443,
						"y": 1170,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "track_button_24.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 118,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 118,
						"h": 109
					},
					"frame": {
						"x": 1573,
						"y": 1170,
						"w": 118,
						"h": 109
					}
				},
				{
					"filename": "track_button_24_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 118,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 118,
						"h": 109
					},
					"frame": {
						"x": 1268,
						"y": 1181,
						"w": 118,
						"h": 109
					}
				},
				{
					"filename": "track_button_24_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 118,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 118,
						"h": 109
					},
					"frame": {
						"x": 1069,
						"y": 1230,
						"w": 118,
						"h": 109
					}
				},
				{
					"filename": "track_button_23.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 117,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 117,
						"h": 109
					},
					"frame": {
						"x": 889,
						"y": 1272,
						"w": 117,
						"h": 109
					}
				},
				{
					"filename": "track_button_23_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 117,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 117,
						"h": 109
					},
					"frame": {
						"x": 669,
						"y": 1315,
						"w": 117,
						"h": 109
					}
				},
				{
					"filename": "track_button_10.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 82,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 82,
						"h": 109
					},
					"frame": {
						"x": 788,
						"y": 1315,
						"w": 82,
						"h": 109
					}
				},
				{
					"filename": "track_button_23_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 117,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 117,
						"h": 109
					},
					"frame": {
						"x": 481,
						"y": 1385,
						"w": 117,
						"h": 109
					}
				},
				{
					"filename": "track_button_10_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 82,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 82,
						"h": 109
					},
					"frame": {
						"x": 298,
						"y": 1423,
						"w": 82,
						"h": 109
					}
				},
				{
					"filename": "track_button_10_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 82,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 82,
						"h": 109
					},
					"frame": {
						"x": 382,
						"y": 1423,
						"w": 82,
						"h": 109
					}
				},
				{
					"filename": "track_button_0.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 81,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 81,
						"h": 105
					},
					"frame": {
						"x": 137,
						"y": 1492,
						"w": 81,
						"h": 105
					}
				},
				{
					"filename": "track_button_0_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 81,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 81,
						"h": 105
					},
					"frame": {
						"x": 1,
						"y": 1517,
						"w": 81,
						"h": 105
					}
				},
				{
					"filename": "track_button_0_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 81,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 81,
						"h": 105
					},
					"frame": {
						"x": 1693,
						"y": 1217,
						"w": 81,
						"h": 105
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:7a5f2f8627c18d3c20a953c4a0110b1f:cfb70ce1462e9806dfdacd94f57ec70a:07dc4f1860622bc85a4e15d42e395f26$"
	}
};